export default __webpack_public_path__ + "static/interval-films-27b6b9b3086f5f4eddb6e616348b762a.jpg";